module.exports = __webpack_public_path__ + "img/premier-service-logo.7914b812.jpg";